exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".file-list-container {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  background-color: #dcdcdc;\n  border-radius: 5px;\n  padding: 10px;\n  overflow: auto; }\n\n.delete-file {\n  padding-left: 10px; }\n", ""]);

